import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBlogPosts } from '../services/api';
import SEO from '../components/SEO';

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await getBlogPosts();
        setPosts(response.data);
      } catch (error) {
        console.error('Error fetching blog posts:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen">
      <SEO 
        title="İstanbul Hikayeleri"
        description="İstanbul'un tarihi, kültürü ve gizli köşeleri hakkında ilham verici hikayeler. Sultanahmet, Balat, Galata ve daha fazlası."
      />
      
      {/* Header */}
      <section className="bg-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-testid="blog-page-title">
            İstanbul Hikayeleri
          </h1>
          <p className="text-lg text-gray-300">
            İstanbul'un tarihi, kültürü ve gizli köşelerini keşfedin
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3].map((i) => (
                <div key={i} className="bg-white rounded-2xl overflow-hidden border border-gray-100 animate-pulse">
                  <div className="h-64 bg-gray-200"></div>
                  <div className="p-6">
                    <div className="h-6 bg-gray-200 rounded mb-4"></div>
                    <div className="h-4 bg-gray-200 rounded mb-2"></div>
                    <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                  </div>
                </div>
              ))}
            </div>
          ) : posts.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-xl text-gray-600">Henüz blog yazısı bulunmamaktadır.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-posts-list">
              {posts.map((post) => (
                <Link
                  to={`/istanbul-hikayeleri/${post.slug}`}
                  key={post.id}
                  className="group bg-white rounded-2xl overflow-hidden border border-gray-100 transition-all hover:-translate-y-1 hover:shadow-xl"
                  data-testid={`blog-post-${post.slug}`}
                >
                  <div className="relative overflow-hidden h-56">
                    <img
                      src={post.image_url || 'https://images.pexels.com/photos/3264723/pexels-photo-3264723.jpeg?w=800'}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://images.pexels.com/photos/3264723/pexels-photo-3264723.jpeg?w=800';
                      }}
                    />
                  </div>
                  <div className="p-6">
                    <div className="text-sm text-orange-500 font-ui font-bold mb-2">{post.category}</div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-orange-500 transition-colors">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 line-clamp-3">{post.excerpt}</p>
                    <div className="mt-4 text-sm text-gray-500">
                      {post.author} • {new Date(post.created_at).toLocaleDateString('tr-TR')}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
